// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconstyle[data-v-e19dd1ec] {\n  width: 12px;\n  height: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
